import { Reducer } from "redux"
import { AuthUserType, TaskAPIType } from "../../../Actions/Types"
import { updateAt } from "../../../Helpers/Functions/reducer"
import {
    TaskModel,
    UITaskModel,
    APITaskListParams,
    getTaskID,
    APITaskDetailsModel
} from "../../../Models/API/TaskModel"
import { FetchState } from "../../../Models/Client/FetchState"
import {
    getInitialData,
    RemoteData,
    setPage
} from "../../../Models/Client/RemoteData"
import { Result } from "../../../Models/Utility/Result"
import { AuthAction } from "../../Auth"
import { JobAction } from "../Job/JobReducer"

export interface ITaskState {
    table: {
        [jobID: string]:
            | RemoteData<UITaskModel, APITaskListParams, string>
            | undefined
    }
    details: {
        [jobID: string]: {
            [taskID: string]: FetchState<APITaskDetailsModel>
        }
    }
}

export type TaskState = ITaskState

interface TaskSetListAction {
    type: TaskAPIType.setList
    meta: {
        versionJobId: string
        page: number
        total: number
        params: APITaskListParams
    }
    payload: TaskModel[]
}

interface TaskSetDetailsAction {
    type: TaskAPIType.setDetails
    meta: {
        versionJobId: string
        taskID: string
    }
    payload: APITaskDetailsModel
}

export type TaskAction = TaskSetListAction | TaskSetDetailsAction

const initialState: TaskState = {
    table: {},
    details: {}
}

export const TaskReducer: Reducer<
    TaskState,
    TaskAction | JobAction | AuthAction
> = (state = initialState, action): TaskState => {
    switch (action.type) {
        case TaskAPIType.setList: {
            const jobID = action.meta.versionJobId

            return {
                ...state,
                table: updateAt(state.table, jobID, table =>
                    setPage(
                        table ?? getInitialData(),
                        action.meta.params,
                        action.payload.map((task, index) => ({
                            ...task,
                            taskNumber: index + 1
                        })),
                        getTaskID,
                        action.meta.page,
                        action.meta.total
                    )
                )
            }
        }
        case TaskAPIType.setDetails: {
            const jobID = action.meta.versionJobId
            const taskID = action.meta.taskID

            return {
                ...state,
                details: {
                    ...state.details,
                    [jobID]: {
                        ...state.details[jobID],
                        [taskID]: Result.ok(action.payload)
                    }
                }
            }
        }
        case AuthUserType.signedOut:
            return initialState
        default:
            return state
    }
}
